/* eslint-disable */
import React, { useState, useEffect } from 'react'
import Flex from 'components/Flex'
import Avatar from 'components/Avatar'
import PluginLiveLogo from 'components/icons/PluginLiveLogo'
import AlertIcon from 'components/icons/AlertIcon'
import ArrowDown from 'components/icons/ArrowDown'
import ManageIcon from 'components/icons/ManageIcon'
import {
  StyledFlex,
  IconWrapper,
  Divider,
  Name,
  Address,
  Institute,
  NameAdd,
  ManageFlex,
  DropMenu,
  Outerdiv,
  NameDiv,
  EmailDiv,
  ManageText,
  NotificationDiv,
} from 'modules/Page/Components/Partials/style'

import { Dropdown } from 'antd'
import { Link } from 'react-router-dom'
import { getCollege } from 'modules/Resume/actions'
import { useDispatch, useSelector } from 'react-redux'
import Notification from 'modules/Page/Components/Partials/NotificationDrawer/index'
import NotificationIcon from '../../../../components/icons/NotificationIcon'
import AccountSwitcher from 'components/AccountSwitcher'

const Header = ({
  isOnboarding,
  collegeData,
  signOut,
  studentData,
  getNotificationsList,
  notificationData,
  markNotificationReadApi,
}) => {
  const dispatch = useDispatch()
  let stdData = useSelector(state => state?.studentData?.studentDetails)
  const instituteId = useSelector(
    state => state?.studentData?.studentDetails?.instituteCampusId
  )
  const [drawer, setDrawer] = useState(false)
  useEffect(() => {
    if (instituteId) {
      !isOnboarding && dispatch(getCollege())
    }
  }, [instituteId])

  const showDrawer = () => {
    setDrawer(true)
  }
  const CheckInstLogo = logo => {
    if (logo === null) {
      return (
        <Avatar
          background
          size={36}
          IconName={collegeData?.campusName[0]}
          font={18}
        />
      )
    } else {
      return <Avatar size={36} src={collegeData?.campusLogoUrl} />
    }
  }

  const CheckUserlogo = (logo, sizevalue) => {
    if (logo === null) {
      return (
        <Avatar
          background
          size={sizevalue}
          IconName={studentData?.admin.firstName[0]}
          font={18}
        />
      )
    } else {
      return <Avatar size={sizevalue} src={studentData?.student?.profileUrl} />
    }
  }

  const onLogout = () => {
    signOut()
    localStorage.clear()
    window.location.href = '/'
  }
  const menu = (
    <DropMenu
      items={[
        {
          label: (
            <Outerdiv>
              {CheckUserlogo(studentData?.student?.profileUrl, 100)}
              <NameDiv>
                {studentData?.admin?.firstName} {studentData?.admin?.lastName}
              </NameDiv>
              <EmailDiv>{studentData?.admin?.email}</EmailDiv>
            </Outerdiv>
          ),
          key: '0',
        },
        {
          type: 'divider',
        },
        {
          label: (
            <Link to="/manageprofile">
              <ManageFlex>
                <Avatar src={<ManageIcon />} />

                <ManageText>Manage Profile</ManageText>
              </ManageFlex>
            </Link>
          ),
          key: '1',
        },
        {
          type: 'divider',
        },
        {
          label: (
            <div style={{ maxWidth: '280px', overflow: 'hidden' }}>
              <AccountSwitcher currentJourney="student" />
            </div>
          ),
          key: 'account-switcher',
        },
        {
          type: 'divider',
        },
        {
          label: (
            <ManageFlex onClick={onLogout}>
              <Avatar size={36} src={<AlertIcon />} />
              <ManageText>Logout</ManageText>
            </ManageFlex>
          ),
          key: '3',
        },
      ]}
    />
  )
  return (
    <>
      <StyledFlex spaceBetween centerVertically isDisplay={true}>
        <Flex centerVertically>
          <IconWrapper>
            <PluginLiveLogo />
          </IconWrapper>
          <Divider />
          {!stdData?.isExpCandidate && (
            <Institute alignCenter>
              {CheckInstLogo(collegeData?.campusLogoUrl)}
              <NameAdd column flexStart>
                <Name>{collegeData?.campusName}</Name>
                <Address>
                  {collegeData?.city}, {collegeData?.state}
                </Address>
              </NameAdd>
            </Institute>
          )}
        </Flex>
        {!isOnboarding && (
          <Flex centerVertically>
            <NotificationDiv>
              <Avatar
                onClick={() => showDrawer()}
                padding={'10px'}
                size={36}
                src={<NotificationIcon />}
              />
            </NotificationDiv>
            &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;
            <Dropdown overlay={menu} trigger={['click']}>
              <Flex>
                {CheckUserlogo(studentData?.student?.profileUrl, 36)}
                <Avatar
                  padding={'10px 0px 0px 0px'}
                  size={36}
                  src={<ArrowDown />}
                />
              </Flex>
            </Dropdown>
          </Flex>
        )}
      </StyledFlex>

      {drawer && (
        <Notification
          notification={drawer}
          setNotification={setDrawer}
          userData={stdData}
          getNotificationsList={getNotificationsList}
          notificationData={notificationData}
          markNotificationReadApi={markNotificationReadApi}
        />
      )}
    </>
  )
}
export default Header
